import { OrgData, UserData } from '@omnea-app/fe-auth/UserSessionProvider'
import { MultiContextWithUser } from '@omnea-app/packages/universal/ld-feature-flags/src/contexts'

export const buildContext = (org: OrgData, user: UserData): MultiContextWithUser => ({
  kind: 'multi',
  organisation: {
    kind: 'organisation',
    key: org.organisationId,
    name: org.name,
    isQa: org.isQaOrg,
  },
  user: {
    kind: 'user',
    key: user.id,
    email: user.email,
    name: `${user.firstName} ${user.lastName}`,
    firstName: user.firstName,
    lastName: user.lastName,
    role: user.role,
  },
})
